import React from "react";

const Header = () => {
    return(
        <div>
           <div className="list-books-title">
            <h1>MyReads</h1>
          </div>
        </div>
    )
}

export default Header